import {Component} from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const styles = theme => ({
    link: {
        color: theme.colors.primary
    }
});

class Disclosure extends Component {
    static propTypes = {
        collapsed: PropTypes.bool,
        title: PropTypes.string
    };

    static defaultProps = {
        collapsed: true
    };

    constructor(props) {
        super(props);
        this.state = {
            collapsed: props.collapsed
        };
        this.onHeaderClick = this.onHeaderClick.bind(this);
    }

    onHeaderClick() {
        const {collapsed} = this.state;
        this.setState({
            collapsed: !collapsed
        });
    }

    render() {
        const {title, children, classes = {}} = this.props;
        const {collapsed} = this.state;

        return (
            <div className="disclosure">
                <div className="disclosure-title">
                    <a className={classes.link} onClick={this.onHeaderClick}> {collapsed ? '+' : '-'} {title}</a>
                </div>
                {collapsed ? null : <div className="disclosure-body">{children}</div>}
            </div>
        );
    }
}

export default injectSheet(styles)(Disclosure);
